export default {
    data () {
        return {
            countdownCurrentTimestamp: '',
            countdownEndTimestamp: '',
        }
    },

    mounted: function () {
        this.setCurrentTimestamp();

        setInterval(() => {
            this.setCurrentTimestamp();
        }, 1000)
    },

    methods: {
        setCountdownEndTimestamp (timestamp) {
            this.countdownEndTimestamp = timestamp;
        },

        setCurrentTimestamp () {
            this.countdownCurrentTimestamp = Date.now();
        }
    },

    computed: {
        countdownFinished () {
            if (this.countdownCurrentTimestamp && this.countdownEndTimestamp) {
                return this.countdownCurrentTimestamp > this.countdownEndTimestamp;
            }

            return true;
        },

        countdownTimeLeft () {
            return this.countdownEndTimestamp
                ? Math.abs(this.countdownCurrentTimestamp - this.countdownEndTimestamp)
                : '';
        },

        countdownDaysLeft () {
            return this.countdownEndTimestamp
                ? Math.floor(this.countdownTimeLeft / (1000 * 3600 * 24))
                : '';
        },

        countdownDaysLabel () {
            return this.countdownEndTimestamp
                ? ' дней'
                : '';
        },

        countdownHoursLeft () {
            return this.countdownEndTimestamp
                ? Math.floor((this.countdownTimeLeft - (this.countdownDaysLeft * (1000 * 3600 * 24))) / (1000 * 3600))
                : '';
        },

        countdownHoursLabel () {
            return this.countdownEndTimestamp
                ? ' часов'
                : '';
        },

        countdownMinutesLeft () {
            return this.countdownEndTimestamp
                ? Math.floor((this.countdownTimeLeft - (this.countdownDaysLeft * (1000 * 3600 * 24)) - this.countdownHoursLeft * (1000 * 3600)) / (1000 * 60))
                : '' ;
        },

        countdownMinutesLabel () {
            return this.countdownEndTimestamp
                ? ' минут'
                : '' ;
        },

        countdownSecondsLeft () {
            return this.countdownEndTimestamp
                ? Math.floor((this.countdownTimeLeft - (this.countdownDaysLeft * (1000 * 3600 * 24)) - this.countdownHoursLeft * (1000 * 3600) - this.countdownMinutesLeft * (1000 * 60)) / 1000)
                : '';
        },

        countdownSecondsLabel () {
            return this.countdownEndTimestamp
                ? ' секунд'
                : '';
        },

        countdownMinutesWithLeadingZeroLeft () {
            let countdownMinutesLeft = this.countdownMinutesLeft;

            return ((parseInt(countdownMinutesLeft) < 10) ? '0' : '') + countdownMinutesLeft;
        },

        countdownSecondsWithLeadingZeroLeft () {
            let countdownSecondsLeft = this.countdownSecondsLeft;

            return ((parseInt(countdownSecondsLeft) < 10) ? '0' : '') + countdownSecondsLeft;
        }
    }
};
